import { ModelSagres } from "@/types/model-sagres";

export interface AndamentoJson {
  IdAndamento: number;
  IdManifestacao: number;
  IdUsuario: string
  DataHora: Date;
  Tipo: string;
  Descricao: string;
  Status: string;
  IdManifestacaoNavigation: number;
}

export class Andamento extends ModelSagres {
  idAndamento: number;
  idManifestacao: number;
  idUsuario: string
  dataHora: Date;
  tipo: string;
  descricao: string;
  status: string;
  idManifestacaoNavigation: number;

  constructor(obj?: AndamentoJson) {
    super();
    if (obj) {
      this.idAndamento = obj.IdAndamento;
      this.idManifestacao = obj.IdManifestacao;
      this.idUsuario = obj.IdUsuario
      this.dataHora = new Date(obj.DataHora);
      this.tipo = obj.Tipo;
      this.descricao = obj.Descricao;
      this.status = obj.Status;
      this.idManifestacaoNavigation = obj.IdManifestacaoNavigation;
    }
  }
}
